import { Stack, useTheme } from "@mui/material";
import { TrendingDown, TrendingUp } from "lucide-react";
import type { FC } from "react";
import { isEvaluationNearZero } from "web_myplann/Dashboard/Utils/isEvaluationNearZero";
import { PercentageDelta } from "web_myplann/Shared/Components/PercentageDelta";

type Props = {
	evaluation: number;
};

export const EvaluationDelta: FC<Props> = ({ evaluation }) => {
	const { palette, iconSize, spacingTokens } = useTheme();
	const white = palette.darkmodeText.white;
	const isNearZero = isEvaluationNearZero(evaluation);

	return (
		<Stack direction="row" alignItems="center" gap={spacingTokens.xs}>
			{!isNearZero &&
				(evaluation > 0 ? (
					<TrendingUp size={iconSize.sm} color={white} />
				) : (
					<TrendingDown size={iconSize.sm} color={white} />
				))}
			<PercentageDelta
				change={isNearZero ? 0 : evaluation}
				variant="bodyMedium"
				color={white}
			/>
		</Stack>
	);
};
